import cn from 'classnames';
import type { Image } from 'models';
import type { RefObject } from 'react';
import { Avatar } from '../avatar';
import { Col } from '../col';
import { type InputRef, TextInput } from '../form';
import { Row } from '../row';

type P = {
  className?: string;
  content: {
    inputName: string;
    label: string;
    placeholder: string;
  };
  inputClassName?: string;
  inputRef?: RefObject<InputRef | null>;
  onRequestInput: () => void;
  profilePhoto?: Image;
};

const PlaceholderComponent = ({
  className,
  content: { inputName, label, placeholder },
  inputClassName,
  inputRef,
  onRequestInput,
  profilePhoto,
}: P) => (
  <Row className={cn('ui-placeholder-input', className)} gutter={['xs', 'xs']}>
    <Col flex="0 1 0">
      <Avatar photo={profilePhoto?.url} size="default" />
    </Col>
    <Col flex="1 0 0">
      <TextInput
        input={{
          onFocus() {
            onRequestInput();
          },
          placeholder,
          ref: inputRef,
        }}
        item={{
          className: inputClassName,
          hideLabel: true,
          label,
          name: inputName,
        }}
      />
    </Col>
  </Row>
);

export default PlaceholderComponent;
